
import { defineComponent, PropType } from 'vue';
import { hashColorClassNames } from '@/utils/colors';
import { SelectedCourseInfo } from '../types';

export default defineComponent({
  props: {
    selectedCourses: { type: Array as PropType<SelectedCourseInfo[]>, required: true },
  },
  setup() {
    return {
      hashColorClassNames,
    };
  },
});
